import { Controller } from 'react-hook-form'

export default ({
  name,
  control,
  label,
  defaultValue = false,
  disabled = false,
  validator = {},
  className = ""
}) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    render={({ field }) => (
      <div className={className}>
        <label 
          className={`label cursor-pointer ${validator.hasError ? "validator" : ''}`}
          {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        >
          <span className="mr-2">{label}</span>
          <input 
            {...field}
            type="checkbox" 
            className="toggle toggle-md"
            checked={field.value === null ? defaultValue : !!field.value }
            value={field.value === null ? defaultValue : !!field.value }
            onChange={(e) => field.onChange(e.target.checked)}
            disabled={disabled}
          />
        </label>
        {validator.getErrorMessage && (
          <div className="validator-hint hidden mt-0 empty:py-[0.6rem]">
            {validator.getErrorMessage(name)}
          </div>
        )}
      </div>
    )}
  />
)